import React, { createContext, useEffect, useState } from 'react'
// import AdmissionForm from './AdmissionForm';

export const FormContext = createContext();

export default function Provider(props) {


    const [formData, setFormData] = useState({
        fullName: '',
        dob: '',
        parentName: '',
        gender: '',
        address: '',
        contactno: '',
        alternateNumber: '',
        email: '',
        pincode: '',
        emergency: '',
        proofOfIdentity: '',
        image: null,
        imagePreview: '',
        profilePic: null,
        profilePreview: ''
    });
    console.log(formData)

    const [academicInfo, setAcademicInfo] = useState({
        instituteName: "",
        courseName: "",
        deptName: "",

        passout: "",
        location: ""
    });
    console.log(academicInfo)

    const [employmentData, setemploymentData] = useState({
        company: "",
        designation: "",
        experience: "",
        location: "",
        joineddate: "",
        enddate: "",
        currentlyWorking: false,

    });
    const today = new Date().toISOString().split('T')[0];
    const [registerinfo, setRegisterInfo] = useState({
        registrationDate: today,
        courseName: "",
        batchStartDate: "",
        batchEndDate: "",
        hearAboutUs: "",
        reasons: "",
        feeMethod: "",
        uploadFile: null,
        imagePreviews: ''

    })
    console.log(registerinfo)

    // Admin Dashboard - Fetching Students Data
    const api = process.env.REACT_APP_URL



    const [Auth, setAuth] = useState(null)


    useEffect(() => {

        if (api) {

            console.log("Checking authentication with API:", api);
            fetch(`${api}/checkauth`, {
                method: "GET",
                credentials: 'include'
            })
                .then(res => res.json())
                .then(data => {
                    console.log("Data comes", data)
                    if (data.success === true) {
                        setAuth(data.user)

                    }
                    else {
                        setAuth(false)
                    }
                })
                .catch(err => {
                    console.log("error fetching in checkauth", err)
                })

        }

    }, [api])

    console.log("Auth:", Auth); // Debug line

    const [studentsData, setStudentsData] = useState(null);

    useEffect(() => {
        console.log("Fetching students data from:", api);
        const fetchStudentsData = async () => {
            try {
                const response = await fetch(`${api}/all-studentsData`, {
                    method: "GET",
                    credentials: 'include'
                });
                const data = await response.json();

                // if (!data.success) {
                //     console.warn(data.message); // Optional: Show alert or message to user
                //     return;
                // }
                console.log("Fetched students data:", data);
                setStudentsData(data.Studentsdata); // Make sure key matches backend
            } catch (error) {
                console.log('Error fetching students data:', error);
            }
        };

        fetchStudentsData();
    }, [Auth, api]);


    const [editPersonal, setEditPersonal] = useState({
        id: '',
        personalData: {
            name: '',
            dob: '',
            gender: '',
            guardianName: '',
            address: '',
            pincode: '',
            contact: '',
            alternateNumber: '',
            email: '',
            emergencyContact: '',
            proof: '',
            proofImage: null,
            profilePic: null
        },

        academicDetails:
        {
            instituteName: '',
            deptName: '',
            courseName: '',
            passout: '',

            location: '',
        },

        employmentInfo: {
            companyName: '',
            designation: '',
            exp: 0,
            JoinedDate: null,
            EndDate: null,
            isactive: false,
            companyLocation: '',
        },
        registration:
        {
            registerDate: '',
            course: '',
            batchStart: '',
            batchEnd: '',
            aboutUs: {
                type: '',
                extraInfo: '',
            },
            feeMethod: '',
            signature: null,
        },
    });
    const [imagePreview, setImagePreview] = useState(null);
    const [imageProfilePreview, setImageProfilePreview] = useState(null);

    const [imagePre, setImagePre] = useState(null);

    const data = {
        formData, setFormData, academicInfo, setAcademicInfo, registerinfo, setRegisterInfo, employmentData, setemploymentData, studentsData, Auth, setAuth,
        editPersonal, setEditPersonal, imagePreview, setImagePreview, imagePre, setImagePre, imageProfilePreview, setImageProfilePreview
    }
    return (
        <FormContext.Provider value={data}>
            {props.children}
        </FormContext.Provider>
    )
}
